/* eslint-disable no-restricted-globals */
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Spinner from "./components/Spinner/Spinner";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from "./ErrorBoundary";

ReactDOM.render(
  <ErrorBoundary>
    <React.StrictMode>
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      self.dispatchEvent(
        new CustomEvent("show-update-popup", {
          detail: { onConfirm: () => registration.waiting.postMessage({ type: "SKIP_WAITING" }) },
        })
      );
    }
  },
});
